import * as React from 'react';
import { useContext } from 'react';

export type PortfolioProjectCheckContextType = {
  isPortfolioProject?: boolean;
  isLoadingPortfolioProject?: boolean;
};

const PortfolioProjectCheckContext = React.createContext<PortfolioProjectCheckContextType | undefined>(undefined);

export const usePortfolioProject = () => {
  return useContext(PortfolioProjectCheckContext) || {};
};

export default PortfolioProjectCheckContext;
